import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { WithClassName } from "shared/types/WithClassName"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "../../styles/_product-configurator-step-summary-card.scss"

export interface ProductConfiguratorStepSummaryCardProps extends WithClassName {
  title: string
  subtitle?: string
  editLabel?: string
  onEdit?: () => void
  children?: React.ReactNode
}

export const ProductConfiguratorStepSummaryCard = React.memo(
  ({
    title,
    subtitle,
    editLabel,
    onEdit,
    children,
    className
  }: ProductConfiguratorStepSummaryCardProps) => {
    const { t } = useTranslation()

    return (
      <section
        className={classNames(
          "product-configurator-step-summary-card",
          "card",
          "card--elevated",
          className
        )}
      >
        <div className="product-configurator-step-summary-card__header">
          <div className="product-configurator-step-summary-card__titles">
            <div className="product-configurator-step-summary-card__title">
              {title}
            </div>
            {subtitle ? (
              <div className="product-configurator-step-summary-card__subtitle">
                {subtitle}
              </div>
            ) : null}
          </div>
          {onEdit ? (
            <Button
              isIconOnly
              variant={ButtonVariant.TERTIARY}
              icon={IconName.EDIT}
              iconSize={IconSize.MEDIUM}
              label={editLabel ?? t("General.Edit")}
              onClick={onEdit}
              data-testid="product-configurator-step-summary-card--edit-button"
            />
          ) : null}
        </div>
        <div className="product-configurator-step-summary-card__body">
          <ScrollArea.Root className="scroll-area scroll-area--vertical product-configurator-step-summary-card__scroll">
            <ScrollArea.Viewport className="scroll-area__viewport">
              <ScrollArea.Content className="scroll-area__content">
                {children}
              </ScrollArea.Content>
            </ScrollArea.Viewport>
            <ScrollArea.Scrollbar
              orientation="vertical"
              className="scroll-area__scrollbar"
            >
              <ScrollArea.Thumb className="scroll-area__thumb" />
            </ScrollArea.Scrollbar>
          </ScrollArea.Root>
        </div>
      </section>
    )
  }
)
